<template>
  <div id="stats" class="alert alert-light mt-2 d-flex flex-row justify-content-between">
    <div>
      <span>
        <strong>{{ $t('stats.total-applications') }}</strong>
      </span>
      <strong class="pl-1">{{ applications.length }}</strong>
    </div>
    <div class="pl-2">
      <span>
        <strong>{{ $t('stats.granted') }}</strong>
      </span>
      <strong class="pl-1">{{ granted }}</strong>
    </div>
    <div class="pl-2">
      <span class>
        <strong>{{ $t('stats.inprocess') }}</strong>
      </span>
      <strong class="pl-1">{{ inProcess }}</strong>
    </div>
    <div class="pl-2">
      <span class>
        <strong>{{ $t('stats.smp') }}</strong>
      </span>
      <strong class="pl-1">{{ smpApproved }}</strong>
    </div>
    <div class="pl-2">
      <span class>
        <strong>{{ $t('stats.area') }}</strong>
      </span>
      <strong class="pl-1">{{ area }} hectares</strong>
    </div>
  </div>
</template>
<script>
import * as _ from "lodash";
import numeral from "numeral";
export default {
  props: ["applications"],
  computed: {
    granted() {
      return _.filter(this.applications, app => {
        return app.concession_status === "0";
      }).length;
    },
    inProcess() {
      return _.filter(this.applications, app => {
        return app.concession_status === "2";
      }).length;
    },
    smpApproved() {
      return _.filter(this.applications, app => {
        return app.smp_approved;
      }).length;
    },
    area() {
      let total = _.reduce(
        this.applications,
        (count, app) => {
          return count + app.area;
        },
        0.00
      );
      return numeral(total).format("0,0");
    }
  }
};
</script>
<style scoped>
#stats {
  border: 1px solid lightgrey;
  border-radius: 4px;
  margin: 0 15px 0 15px;
}
.alert-light {
  color: #2c3e50;
}
</style>
